<template>
  <div
    class="SB-border bottom"
    :class="{ 'full-width': fullWidth }" />
</template>

<script>
export default {
  name: 'Divider',
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.full-width {
  width: calc(100% + 24px);
  margin-left: -12px;
}
</style>
